import * as React from "react";
import { action, observable } from "mobx";
import { inject, observer } from "mobx-react";
import SeekerStore from "../../stores/seekerStore";
import { Route } from "react-router";
import { Row, Col, Grid } from "react-flexbox-grid";
import Busy from "../../components/widgets/busy";
import Header from "../../components/app/header";
import NavBarMobile from "../../components/app/navbarMobile";
import Footer from "../../components/app/footer";
import TermsAndConditionsDlg from "../../components/dialogs/termsAndConditions";
import Disclaimer from "../../components/dialogs/disclaimer";
import PrivacyPolicyDlg from "../../components/dialogs/privacyPolicy";
import { Auth } from "../../utils/auth";
import { ScreenMode } from "../../models/enums";
import SideNav from "../../components/app/sideNav";
import ExternalLinkDlg from "../../components/dialogs/externalLink";
import StartVw from "../start";
import HelpVw from "../help";
import routeList from "../appBody/routes";
import * as s from "./app.css";
import { IconButton, Drawer, List, TextField, Button, ListItem, ListItemText, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "material-ui";
import ChevronRightIcon from "material-ui-icons/ChevronRight";
import { HelpTopic } from "../../models/integratedHelp";


@inject("store") @observer
export default class App extends React.Component<{ store: SeekerStore }, {}> {
  @observable updatePwd: boolean;
  @observable helpDrawer: boolean = false;
  @observable helpForm = false;
  @observable wHeight: number;
  @observable selectedTopic: HelpTopic;
  @observable openTopicDialog = false;
  @observable msg = "";
  @observable email = "";
  @observable sending = false;
  constructor(props: any) {
    super(props);
    this.updatePwd = false;
    this.wHeight = this.helpForm ? window.innerHeight - 425 : window.innerHeight - 225;
    window.addEventListener('resize', this.handleResize);
    this.selectedTopic = null;
  }
  validEmail(value: string): boolean {
    const emailRex: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  @action setPassword = (): void => {
    this.updatePwd = true;
  }
  @action hidePasswordDlg = (): void => {
    this.updatePwd = false;
  }
  componentWillUnmount(): void {
    window.removeEventListener('resize', this.handleResize);
  }
  @action handleResize = (): void => {
    this.wHeight = this.helpForm ? window.innerHeight - 510 : window.innerHeight - 310;
  }
  @action toggleHelpDrawer = () => {
    this.helpDrawer = !this.helpDrawer;
  }
  @action toggleHelpForm = (): void => {
    this.helpForm = !this.helpForm;
    this.handleResize();
  }
  @action setTopic = (topic: HelpTopic): void => {
    this.selectedTopic = topic;
    this.openTopicDialog = true;
  }
  @action closeDialog = (): void => {
    this.openTopicDialog = false;
    this.selectedTopic = null;
  }
  // # contact request
  @action cancel = (): void => {
    this.msg = "";
    this.toggleHelpForm();
  }
  @action handleChange = (e: any): void => {
    this[e.target.id] = e.target.value;
  }
  @action handleSubmit = (): void => {
    this.sending = true;
    this.props.store.submitHelpRequest(this.msg, this.email, this.handleResponse);
  }
  @action handleResponse = (success: boolean): void => {
    this.sending = false;
    if (success) {
      this.props.store.viewState.setShowSnackbar(true, "Sent");
      this.cancel();
    } else {
      this.props.store.viewState.setShowSnackbar(true, "Error: Message failed to send.");
    }
  }
  // # end
  @action openRedirect = (url: string): void => {
    window.open(url, '_blank');
  }

  renderHelpButton(isMobile: boolean): JSX.Element {
    const helpIc = "./images/helpIcon.png";
    const helpButton: any = {
      position: "fixed",
      bottom: isMobile ? "4px" : "24px",
      right: "-5px",
      zIndex: 1000,
      width: "56px",
      padding: "8px",
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0,
      backgroundColor: "#f44336",
      "&:hover": {
        transition: "transform 0.35s",
        transform: "translateX(-5px)",
        backgroundColor: "#f44336"
      }
    } 
    return <IconButton
      onClick={() => this.toggleHelpDrawer()}
      style={helpButton}>
      <img src={helpIc} width="32px" />
      </IconButton>
  }
  renderHelpDrawer(hts: Array<HelpTopic>): JSX.Element {
    const styles: any = {
      helpFooter: {
        position: "absolute",
        bottom: "24px",
        left: "24px",
        width: "82%"
      },
      closeHelpButton: {
        padding: "8px",
        backgroundColor: "#6765654a",
        "&:hover": {
          backgroundColor: "#00000042"
        }
      },
      chevronIcon: {
        color: "#fff",
        width: "32px",
        height: "32px"
      },
      helpLink: {
        color: "#0288d1",
        cursor: "pointer",
        textDecorationLine: "underline",
        fontSize: "14px !important",
        fontWeight: 400
      },
      noContentTxt: {
        paddingLeft: "16px",
        fontSize: "13px"
      },
      helpContentWrapper: {
        overflow: "scroll",
        borderBottom: "1px solid #ccc"
      },
      drawer: {
        width: "240px",
        flexShrink: 0
      },
      drawerPaper: {
        width: "240px"
      },
      listStyle: {
        width: "240px",
        paddingLeft: "4px",
        paddingRight:"4px"
      }
    }
    return <Drawer
      anchor="right"
      open={this.helpDrawer}
      style={styles.drawer}
    >
      <div>
        <p style={{ fontWeight: 500, paddingLeft:"16px"}}>Help Topics</p>
      </div>
      <div style={{ maxHeight: this.wHeight + "px", overflowY: "scroll", borderBottom: "1px solid #ccc" }}>
        {hts.length === 0 && <p style={styles.noContentTxt}>No help topics available</p>}
        <List style={styles.listStyle}>
          {hts.length > 0 && hts.map((ht: HelpTopic, i: number): JSX.Element => {
            return <ListItem divider={false} button key={i} onClick={() => { this.setTopic(ht) }}>
              <ListItemText style={styles.helpLink} primary={ht.title} />
            </ListItem>
          })}
        </List>
      </div>
      <div style={styles.helpFooter}>
        {this.renderHelpForm()}
        <IconButton  style={styles.closeHelpButton} onClick={() => this.toggleHelpDrawer()}>
          <ChevronRightIcon style={styles.chevronIcon} />
        </IconButton>
      </div>
    </Drawer>
  }
  renderHelpForm(): JSX.Element {
    const styles: any = {
      cancelBtn: {
        color: "red",
        marginTop: "5px"
      },
      textArea: {
        backgroundColor: "#efefef",
        marginBottom:"4px"
      },
      contactUsTxt: {
        paddingTop: "16px",
        paddingBottom: "16px"
      },
      helpLink: {
        color: "#0288d1",
        cursor: "pointer",
        textDecorationLine: "underline",
        fontSize: "14px",
        fontWeight: 400
      }
    }
    const webinarLabel: string = this.props.store.localization.fields.help.webinarLabel || "";
    const webinarLink: string = this.props.store.localization.fields.help.webinarLink || "";
    return <div style={styles.contactUsTxt}>
      {this.sending && <p>Sending...</p>}
      {!this.helpForm && <p style={styles.helpLink} onClick={() => this.toggleHelpForm()}>Still need help? Contact us.</p>}
      {webinarLabel.length > 0 && webinarLink.length > 0 && <p>
        <a style={styles.helpLink} href={webinarLink} target="_blank">
          {webinarLabel}
        </a>
      </p>}
      {this.helpForm && <div>
        {!Auth.isAuthenticated && 
          <TextField
            error={this.email.length === 0 || (this.email.length > 0 && !this.validEmail(this.email))}
            fullWidth
            style={styles.textArea}
            value={this.email}
            label="Enter Email"
            onChange={this.handleChange}
            id="email"
          />
        }
        <TextField
          multiline
          fullWidth
          style={styles.textArea}
          value={this.msg}
          label="Submit a request..."
          onChange={this.handleChange}
          rows={10}
          id="msg"
        />
        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button size="small" disabled={this.msg.length === 0 || (!Auth.isAuthenticated && (this.email.length === 0 || (this.email.length > 0 && !this.validEmail(this.email))))} onClick={() => this.handleSubmit()}>Submit</Button>
          <Button size="small" onClick={this.cancel} style={styles.cancelBtn}>Cancel</Button>
        </div>
      </div>}
    </div>;
  }

  renderHelpTopicDialog(): JSX.Element {
    return <Dialog
      open={this.openTopicDialog}
      aria-labelledby="responsive-dialog-title"
      fullScreen={this.props.store.viewState.screenMode === ScreenMode.Mobile} >
      <DialogTitle>{this.selectedTopic ? this.selectedTopic.title : ""}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div dangerouslySetInnerHTML={{ __html: this.selectedTopic ? this.selectedTopic.content : "" }}></div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => this.closeDialog()} >{this.props.store.localization.fields.close}</Button>
      </DialogActions>
    </Dialog >
  }

  renderSplitView(): JSX.Element {
    let item: JSX.Element[] = [];
    if (this.props.store.isInitializing) {
      return null;
    }
    const topics = this.props.store.helpTopics;
    if (Auth.isAuthenticated) {
      return (<div>
        {this.renderHelpButton(false)}
        {this.renderHelpDrawer(topics)}
        {this.renderHelpTopicDialog()}
        <Grid className={s.appGrid}>
          <Row className={s.stretchBody}>
            <Col xs={1} sm={1} md={1} lg={2} xl={2} className={s.navCol}>
            <SideNav store={this.props.store} />
            </Col>           
            <Col xs={11} sm={11} md={11} lg={10} xl={10} className={s.bodyCol}>
            <Header store={this.props.store} />
            <div className={s.bodyContentAuth}>{this.props.children}</div>
            <Footer store={this.props.store} />
            <TermsAndConditionsDlg store={this.props.store} />
            <PrivacyPolicyDlg store={this.props.store} />
            <Disclaimer store={this.props.store} />
          </Col>
        </Row>
          </Grid>
      </div>);
    } else {
      return (<div>
        {this.renderHelpButton(false)}
        {this.renderHelpDrawer(topics)}
        {this.renderHelpTopicDialog()}
        <Header store={this.props.store} />
        <div className={s.bodyContentAnon}>{this.props.children}</div>
        <Footer store={this.props.store} /> 
        <TermsAndConditionsDlg store={this.props.store} />
        <PrivacyPolicyDlg store={this.props.store} />
        <Disclaimer store={this.props.store} />

      </div>);
    }
  }
  renderAppBody(): JSX.Element {
    if (this.props.store.isInitializing) {
      return null;
    }
    const topics = this.props.store.helpTopics;
    return (<div>
      {this.renderHelpButton(true)}
      {this.renderHelpDrawer(topics)}
      {this.renderHelpTopicDialog()}
        <Header store={this.props.store} />
        <div className={s.bodyContentAuth}>{this.props.children}</div>
        <NavBarMobile store={this.props.store} />
        <Footer store={this.props.store} />
        <TermsAndConditionsDlg store={this.props.store} />
        <PrivacyPolicyDlg store={this.props.store} />
        <Disclaimer store={this.props.store} />
      </div>
      );
    }

  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    return (<div>
      <Busy show={this.props.store.isInitializing} size="lg" msg="Loading..." center={true} />
      <ExternalLinkDlg store={this.props.store} />
      {mode === ScreenMode.Mobile && this.renderAppBody()}
      {mode !== ScreenMode.Mobile && this.renderSplitView()}
            </div>);
  }
  componentWillMount(): void {
    Auth.reauthenticate();
  }
  componentDidMount(): void {
    this.props.store.getHelpTopics();
  }
  componentDidUpdate(): void {
    this.props.store.getHelpTopics();
  }
}


// WEBPACK FOOTER //
// ./src/views/app/index.tsx